import gql from 'graphql-tag';
import { companyFieldsFragment } from './companyFieldsFragment';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';

export const participantFieldsFragment = gql`
  fragment AdminParticipantFields on Participant {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    externalId
    name
    email
    phone
    company {
      _ref
    }
    rCompany {
      ...AdminCompanyFields
    }
    archived
  }

  ${sanityDocumentFieldsFragment}
  ${companyFieldsFragment}
`;
